import http from "./http-common";
import Crypto from "./Crypto";
import { getServidor } from "../utils/Utils";

/**
 * @class MarcasDataService
 * @brief Gestiona las operaciones de acceso a los datos de marcas.
 */
class MarcasDataService{
  
    /**
     * @brief Obtiene un listado de todas las marcas registradas.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP con las marcas registradas.
     */
    getAll() {
        return http.get(`${getServidor()}/marca/`);
    }
    /**
     * @brief Obtiene un listado de todas las marcas habilitadas.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP con las marcas habilitadas.
     */
    getAllHabilitadas() {
        return http.get(`${getServidor()}/marca/habilitadas`);
    }
    /**
     * @brief Registra una nueva marca en el sistema.
     *
     * @param data Datos de la marca que se desea registrar.
     * @param key Clave utilizada para realizar la encriptación de los datos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP con la marca registrada.
     */
    async create(data, key){
        const datosEncriptados = await Crypto.encriptar(data, key);
      return http.post(`${getServidor()}/marca/`, datosEncriptados);
    }
    /**
     * @brief Actualiza los datos de una marca en el sistema.
     *
     * @param data Objeto con los nuevos valores de la marca.
     * @param key Clave utilizada para realizar la encriptación de los datos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP con la marca actualizada.
     */
    async update(data, key){
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.put(`${getServidor()}/marca/`, datosEncriptados);
    }
    /**
     * @brief Habilita o deshabilita una marca de GPS en el sistema.
     *
     * @param idMarca Identificador de la marca a modificar.
     * @param key Clave utilizada para realizar la encriptación de los datos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP con la marca actualizada.
     */
    async delete(idMarca, key){
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.delete(`${getServidor()}/marca/`, {data: datosEncriptados} );
    }
}
/**
 * Variable para exportar
 */
export default new MarcasDataService();